module.exports = __webpack_public_path__ + "img/winner10.c89ce2a2.jpg";